const date_today = (new Date()).toISOString().split('T')[0];

[
  'daily_reports__begin_date', 'daily_reports__end_date',
  'material_preparations__date',
  'ng_reports__begin_date', 'ng_reports__end_date',
  'planning_products__date',
  'idle_reports__begin_date', 'idle_reports__end_date'
].forEach(function(val, idx){
  if (sessionStorage.getItem(val) == null) {
    sessionStorage.setItem(val, date_today)
  }
})

window.setSessionValue = function(){
  if ($("[session]").length){
    $("[session]").each(function(idx, elm){
      $(elm).val(sessionStorage.getItem($(elm).attr('session')))
    })
  }
}

$(document).on("change", "[session]", function(){
  const $dom = $(this)
  sessionStorage.setItem($dom.attr("session"), $dom.val())
})